import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "../Shared/Loader";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { setCookie,
  getCookie,
  deleteCookie, } from "../../utility/cookieProvider";
import {
  DASHBOARD,
  DASHBOARD_CONTAINER,
} from "../../constants/route-constants";
import { httpGet, httpPost } from "../../utility/requestHelper";

const DashboardContainer = () => {
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  const history = useHistory();
  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      createDefaultDashboard();
    }
  }, [selectedClient]);

  const createDefaultDashboard = () => {
    httpPost(
      `${unifiedEnvConfig.DEFAULT_DASHBOARD}?client_id=${selectedClient.id}`
    ).then((response) => {
      fetchDashboardsList();
    });

        
    httpGet(`${unifiedEnvConfig.LIMIT}/${selectedClient.id}`).then((res) => {
      if (res) {       
       
        let usernamedata = res.data.data.usernames_metadata;

        let mainstream_media = res.data.data.mainstream_media; //mainstream_media

        localStorage.removeItem("mainstreammedia");

        if(usernamedata != null && usernamedata != '' && usernamedata != undefined){
          //setMainstreammediaChecked(true);
          if(mainstream_media != null && mainstream_media != '' && mainstream_media != undefined){

            if(mainstream_media){
              localStorage.setItem("mainstreammedia", '1');
            } else {
              localStorage.setItem("mainstreammedia", '0');
            }

          }else {
            localStorage.setItem("mainstreammedia", '0');
          }
        } else {
          //setMainstreammediaChecked(false);
          localStorage.setItem("mainstreammedia", '0');
        }

      }
    });

  };

  const fetchDashboardsList = () => {
    const perPage = 10000;
    const page = 1;

    httpGet(
      `${unifiedEnvConfig.GET_DASHBOARDS_LIST}?client_id=${selectedClient.id}&perPage=${perPage}&page=${page}`
    )
      .then((response) => {
        const { status, data } = response.data;
        if (status === 200) {
          if (data && data.length > 0) {
            history.push({
              pathname: `${DASHBOARD_CONTAINER}/${data[0].id}`,
              data: data,
            });
          } else {
            history.push(`${DASHBOARD}`);
          }
        }
      })
      .catch((e) => {
        return e;
      });
  };

  return (
    <div
      style={{
        marginTop: "20%",
      }}
    >
      <Loader />
    </div>
  );
};

export default DashboardContainer;
